import type { DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItem } from './discoveryGetTrends200PageAllOfThreeContentItemContentTweetsItem';

/**
 * 트렌드 관련 콘텐츠
 */
export type DiscoveryGetTrends200PageAllOfThreeContentItemContent = {
  tweets?: DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItem[];
};
